import { createContext } from 'react';

interface ThemeContextType {
    isThemeLoaded: boolean;
}

export const ThemeContext = createContext<ThemeContextType>({ isThemeLoaded: false });
